import type { RouteRecordRaw, Router } from 'vue-router'

const SaleContractRoutes: RouteRecordRaw = {
  path: '/contract/financial/sale',
  name: 'SaleModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'SaleMainRoute',
      component: () => import('./views/SaleView.vue'),
      meta: {
        title: 'sale.saleContract',
      },
    },
    {
      path: 'create',
      name: 'SaleCreateRoute',
      component: () => import('./views/SaleUpsertView.vue'),
      meta: {
        title: 'sale.createSaleContract',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:saleId',
      name: 'SaleEditRoute',
      component: () => import('./views/SaleUpsertView.vue'),
      meta: {
        title: 'sale.editSaleContract',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:saleId',
      name: 'ViewSaleRoute',
      component: () => import('./views/SingleSaleView.vue'),
      meta: {
        title: 'sale.ViewSale',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(SaleContractRoutes)
}
